export default "__VITE_ASSET__BUDETYGC__"